import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryCards from './components/CategoryCards';
import RecentArticles from './components/RecentArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '免费91 网页-官方入口与完整使用指南';
  }, []);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '免费91网页',
    url: 'https://www.free91.com/',
    description: '免费91网页官方入口与完整使用指南，为用户提供访问方式、功能介绍、使用技巧及常见问题解答',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.free91.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '免费91网页',
    url: 'https://www.free91.com/',
    description: '免费91网页为用户提供在线工具和服务的完整指南',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoryCards />
        <RecentArticles />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}